// extracted by mini-css-extract-plugin
module.exports = {"OffsetLink":"OffsetLinkSuccessSummary_OffsetLink__389_d","Label":"OffsetLinkSuccessSummary_Label__1C0kj","Group":"OffsetLinkSuccessSummary_Group__31X7w"};